<template>
    <b-notification
        type="is-success"
        class="notification-content"
        active
        :title="title"
        size="is-small"
        aria-close-label="Close notification"
        @close="$emit('close', id)"
    >
      <template #default>
        <p class="notification-title">{{ title }}</p>
        <p v-html="content"></p>
      </template>
    </b-notification>
</template>

<script>

export default {
  name: 'NotificationNewsAndUpdates',
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: -1,
    },
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped lang="stylus">
.notification-content
  padding 12px 20px
  >>>button.delete
    background-color transparent
    &::before
      background-color #525F66
      transform-origin center center
      width 85%
      transform translateX(-50%) translateY(-50%) rotate(45deg)
    &::after
      background-color #525F66
      transform-origin center center
      height 85%
      transform translateX(-50%) translateY(-50%) rotate(45deg)
@media (max-width 1170px)
  &.notification-content
    font-size: 16px!important
.notification.is-success
  background-color #D2EAD0
  color #1B2228
  font-size 18px
.notification-title
  font-weight bold
  margin-bottom 6px
</style>
